import React from 'react';
import { ItemHeader } from './styles';
import { Title } from '@gerdau/hefesto/Title';
import { DateField } from '@gerdau/hefesto-mais-web/DateField';
import { Button } from '@gerdau/hefesto/Button';
import moment from 'moment';
import { DateType } from '@gerdau/hefesto-mais-web/DateField/DateField.types';
import { ContentDateField } from './styles';
interface IDashboardItemHeader {
  title: string;
  subTitle?: JSX.Element;
  actions?: IDashboardItemAction[];
  selectedMonth?: moment.Moment;
  disableFutureDates?: boolean;
  onSelectMonth?(selectedMonth: moment.Moment): void;
  loading?: boolean;
}

interface IDashboardItemAction {
  description: string;
  onClickAction(): void;
  icon?: JSX.Element | undefined;
}

const BilledByDayItemHeader: React.FC<IDashboardItemHeader> = ({
  title,
  subTitle,
  actions,
  selectedMonth,
  onSelectMonth,
  loading
}) => {
  return (
    <ItemHeader>
      {selectedMonth && onSelectMonth && (
        <ContentDateField>
          <DateField
            name="dateFieldBilledByDay"
            label=""
            selected={
              selectedMonth
                ? moment(selectedMonth, 'MMMM / YYYY').toDate()
                : undefined
            }
            selectsRange={false}
            onChange={(date: Date | [DateType, DateType] | null) =>
              onSelectMonth(moment(date as Date))
            }
            picker="month"
            disabled={loading}
          />
        </ContentDateField>
      )}
      <span>
        <Title level={4}>{title}</Title>
        <span>
          <>{subTitle}</>
        </span>
      </span>
      <div className="actions">
        {actions && actions.length > 0 && (
          <>
            {actions.map((action, idx) => (
              <Button
                name={action.description}
                key={idx}
                onClick={action.onClickAction}
                variant="secondary"
                icon={action.icon}
                loading={loading}
              >
                {action.description}
              </Button>
            ))}
          </>
        )}
      </div>
    </ItemHeader>
  );
};

export default BilledByDayItemHeader;
